<template>
    <div class="bax-checkbox">
        <input
            type="checkbox"
            class="css-checkbox"
        />
    </div>
</template>

<script>
export default {
    name: 'VueInput',
    props: {
        value: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        updateValue(value) {
            this.$emit('input', value);
        },
    },
};
</script>
